import { createClient } from '@supabase/supabase-js'

// 本番環境Supabase設定
const SUPABASE_URL = 'https://icvjbilarzdoxmalseig.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImljdmpiaWxhcnpkb3htYWxzZWlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg4NjE3NDMsImV4cCI6MjA3NDQzNzc0M30.FQu1-A-tycOrYYMJqNBZVresr5KEo9XsMtqIn_5Mo0A'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

export type Team = {
  id: string
  name: string
  description: string | null
  owner_id: string
  created_at: string
  updated_at: string
}

export type TeamMember = {
  id: string
  team_id: string
  user_id: string
  role: 'owner' | 'admin' | 'member'
  joined_at: string
}

export type Project = {
  id: string
  name: string
  description: string | null
  color: string
  is_active: boolean
  show_thumbnail: boolean
  show_in_all_projects: boolean  // 個人プロジェクト用: 「全てのプロジェクト」選択時に表示するかどうか
  user_id: string
  created_at: string
  updated_at: string
  display_order: number
  is_team_project: boolean  // チームプロジェクトかどうか
  team_id: string | null  // 所属チームID
  team?: Team  // チーム情報
  team_role?: 'owner' | 'admin' | 'member'  // 自分のロール
  team_member_count?: number  // チームメンバー数
  user_show_in_all_projects?: boolean  // チームプロジェクト用: 個人設定で「全てのプロジェクト」選択時に表示するかどうか
}

export type UserProjectSetting = {
  id: string
  user_id: string
  project_id: string
  show_in_all_projects: boolean
  created_at: string
  updated_at: string
}

export type TodoImage = {
  id: string
  todo_id: string
  user_id: string
  image_url: string | null
  file_name: string
  file_size: number | null
  display_order: number
  created_at: string
  is_external: boolean
  external_url: string | null
  source: string | null
  photographer: string | null
  photographer_url: string | null
  license_name: string | null
  license_url: string | null
}

export type UserProfile = {
  id: string
  email: string | null
  nickname: string | null
  avatar_url: string | null
}

export type Todo = {
  id: string
  project_id: string
  title: string
  description: string | null
  priority: number
  status: 'pending' | 'in_progress' | 'completed' | 'deleted'
  start_date: string | null  // タスク開始日（ガントチャート用）
  due_date: string | null
  created_at: string
  updated_at: string
  completed_at: string | null
  deleted_at: string | null
  display_order: number
  thumbnail_image_id: string | null
  thumbnail_size: 'small' | 'large'
  project?: Project
  thumbnail_image?: TodoImage
  user_id: string  // タスク作成者ID
  assigned_to_user_id: string | null  // 担当者ID
  assignment_status: 'unassigned' | 'pending' | 'assigned'  // 割り当て状態
  progress_percentage: number  // 進捗率 (0-100)
  assigned_user?: UserProfile  // 担当者情報
  created_by_user?: UserProfile  // 作成者情報
  gantt_sort_order: number | null  // ガントチャート専用の表示順序
}

export type DefaultView = 'tasks' | 'calendar' | 'gantt'

export type ContactMessage = {
  id: string
  user_id: string | null
  name: string
  email: string
  subject: string
  message: string
  status: 'unread' | 'in_progress' | 'completed'
  admin_reply: string | null
  admin_user_id: string | null
  replied_at: string | null
  created_at: string
  updated_at: string
}